import React, { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { FaSmileBeam, FaCheckCircle, FaExclamationTriangle, FaPaperPlane, FaLock } from 'react-icons/fa';
import '../../styles/Ouvidoria.css'; // Reutilizando estilo da Ouvidoria para consistência

// URL da função que criamos no passo 1
const CLOUD_FUNCTION_URL = 'https://enviarhumorpublico-aap3px27dq-rj.a.run.app'; 

const PublicMoodPage = () => {
    const [humor, setHumor] = useState('');
    const [observacao, setObservacao] = useState('');
    const [isAnonymous, setIsAnonymous] = useState(true);
    const [nome, setNome] = useState('');
    const [email, setEmail] = useState('');
    const [empresaId, setEmpresaId] = useState(null);
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [success, setSuccess] = useState(false);
    const [error, setError] = useState('');

    const location = useLocation();

    useEffect(() => {
        const params = new URLSearchParams(location.search);
        const id = params.get('empresaId');
        if (id) setEmpresaId(id);
        else setError('Link inválido: ID da empresa não encontrado.');
    }, [location]);

    const opcoesHumor = [
        { valor: 'muito-feliz', label: '😄 Muito Feliz', cor: '#4CAF50' },
        { valor: 'feliz', label: '🙂 Feliz', cor: '#8BC34A' },
        { valor: 'neutro', label: '😐 Neutro', cor: '#FFC107' },
        { valor: 'triste', label: '😟 Triste', cor: '#FF9800' },
        { valor: 'muito-triste', label: '😭 Muito Triste', cor: '#F44336' },
    ];

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (!humor) return setError('Por favor, selecione como se sente.');
        
        setIsSubmitting(true);
        setError('');

        try {
            const response = await fetch(CLOUD_FUNCTION_URL, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ empresaId, humor, observacao, isAnonymous, nome, email })
            });

            if (!response.ok) throw new Error('Erro ao enviar.');
            setSuccess(true);
        } catch (err) {
            setError('Erro ao registrar. Tente novamente.');
        } finally {
            setIsSubmitting(false);
        }
    };

    if (success) {
        return (
            <div className="ouvidoria-container" style={{maxWidth:'600px', marginTop:'50px', textAlign:'center'}}>
                <div className="ouvidoria-form-card success-message">
                    <FaCheckCircle size={50} className="success-icon" style={{color:'#2ecc71'}} />
                    <h3>Obrigado por compartilhar!</h3>
                    <p>Sua resposta foi registrada e ajuda a construirmos um ambiente melhor.</p>
                </div>
            </div>
        );
    }

    if (error && !empresaId) return <div className="error-message" style={{padding:'20px', textAlign:'center'}}>{error}</div>;

    return (
        <div className="ouvidoria-container" style={{ maxWidth: '600px', marginTop: '3rem' }}>
            <div className="ouvidoria-header">
                <h1>Termômetro de Humor</h1>
                <p className="ouvidoria-subtitle">Como você está se sentindo hoje?</p>
            </div>

            <form onSubmit={handleSubmit} className="public-form" style={{background:'white', padding:'20px', borderRadius:'12px', boxShadow:'0 2px 10px rgba(0,0,0,0.05)'}}>
                
                <div style={{display:'flex', justifyContent:'space-between', marginBottom:'20px', flexWrap:'wrap', gap:'10px'}}>
                    {opcoesHumor.map(opt => (
                        <button
                            type="button"
                            key={opt.valor}
                            onClick={() => setHumor(opt.valor)}
                            style={{
                                flex: '1 1 18%',
                                border: `2px solid ${opt.cor}`,
                                background: humor === opt.valor ? opt.cor : 'transparent',
                                color: humor === opt.valor ? '#fff' : opt.cor,
                                borderRadius: '8px',
                                padding: '10px 5px',
                                cursor: 'pointer',
                                fontWeight: 'bold',
                                transition: 'all 0.2s'
                            }}
                        >
                            <div style={{fontSize:'24px'}}>{opt.label.split(' ')[0]}</div>
                            <div style={{fontSize:'12px'}}>{opt.label.split(' ')[1]}</div>
                        </button>
                    ))}
                </div>

                <div className="form-group">
                    <label>Observação (Opcional):</label>
                    <textarea 
                        className="form-control" 
                        rows="3" 
                        value={observacao} 
                        onChange={e => setObservacao(e.target.value)} 
                        placeholder="Quer compartilhar o motivo?"
                    />
                </div>

                <div className="form-group-toggle" style={{marginTop:'15px'}}>
                    <label className="toggle-label">
                        <input type="checkbox" checked={!isAnonymous} onChange={(e) => setIsAnonymous(!e.target.checked)} className="toggle-checkbox" />
                        <span className="toggle-switch"></span>
                        <span className="toggle-text">Quero me identificar</span>
                    </label>
                </div>

                {!isAnonymous && (
                    <div className="identity-fields" style={{marginTop:'15px', padding:'15px', background:'#f8f9fa', borderRadius:'8px'}}>
                        <div className="form-group">
                            <label>Seu Nome</label>
                            <input type="text" className="form-control" value={nome} onChange={e => setNome(e.target.value)} required />
                        </div>
                        <div className="form-group">
                            <label>Seu E-mail</label>
                            <input type="email" className="form-control" value={email} onChange={e => setEmail(e.target.value)} required />
                        </div>
                    </div>
                )}

                <button type="submit" className="btn-primary btn-submit-ouvidoria" disabled={isSubmitting} style={{width:'100%', marginTop:'20px'}}>
                    {isSubmitting ? 'Enviando...' : 'Enviar Resposta'}
                </button>
                
                <div style={{textAlign:'center', marginTop:'15px', fontSize:'12px', color:'#777'}}>
                    <FaLock /> Suas informações são tratadas com confidencialidade.
                </div>
            </form>
        </div>
    );
};

export default PublicMoodPage;